// teacherSlots/operation.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance.js";

export const fetchTeacherSlots = createAsyncThunk(
  "teacherSlots/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get("/teacher/slots");
      // console.log(data);

      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch slots"
      );
    }
  }
);

export const createTeacherSlot = createAsyncThunk(
  "teacherSlots/create",
  async (slotData, { rejectWithValue }) => {
    try {
      const payload = {
        date: slotData.date,
        start_time: slotData.start_time,
        end_time: slotData.end_time,
        description: slotData.description || "",
        format: slotData.format, // 👈 добавлено!
      };

      const res = await axiosInstance.post("/teacher/create-slot", payload);
      // console.log(payload);

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to create slot"
      );
    }
  }
);

export const deleteTeacherSlot = createAsyncThunk(
  "teacherSlots/delete",
  async (slotId, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/teacher/slots/${slotId}`);

      return slotId; // вернём id удалённого слота
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete slot"
      );
    }
  }
);

export const updateTeacherSlot = createAsyncThunk(
  "teacherSlots/update",
  async ({ slotId, updatedData }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.patch(
        `/teacher/slots/${slotId}`,
        updatedData
      );

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update slot"
      );
    }
  }
);
